import Link from 'next/link';
import styles, { CtaButtonVariant } from './CtaButton.styles';
export interface CtaButtonProps {
  text: string;
  href: string;
  variant?: CtaButtonVariant;
  color?: string;
}
const CtaButton = ({
  text,
  href,
  variant = 'outline',
  color
}: CtaButtonProps) => {
  return <Link href={href} sx={styles.button(variant, color)}>
      {text}
    </Link>;
};
export default CtaButton;